import {
  FETCH_SPACE_ACTIVITIES,
  FETCH_SPACE_ACTIVITIES_SUCCESS,
  FETCH_SPACE_ACTIVITIES_FAILS,
  FETCH_HOME_CATEGORIES,
  FETCH_HOME_CATEGORIES_SUCCESS,
  FETCH_HOME_CATEGORIES_FAILS,
} from '../../redux/actionTypes';

export const spaceActivityReducer = (
  state = {
    error: { status: false, message: '' },
    data: [],
    allData: [],
    homeCategories: [],
    homeCategoriesCountry: null,
    homeCategoriesFetching: false,
  },
  action
) => {
  switch (action.type) {
    case FETCH_SPACE_ACTIVITIES:
      return {
        ...state,
        data: [],
        allData: [],
      };

    case FETCH_SPACE_ACTIVITIES_SUCCESS: {
      // Training activity removed temporarily
      const filteredPayload = action.payload.filter((category) => category.name !== 'Train');
      return {
        ...state,
        data: filteredPayload,
        // the hero search categories still offer Training, so keep the unfiltered list too
        allData: action.payload,
      };
    }

    case FETCH_SPACE_ACTIVITIES_FAILS:
      return {
        ...state,
        data: [],
        allData: [],
      };

    case FETCH_HOME_CATEGORIES:
      // Clear immediately so LK/SG curated chips never mix during a market switch.
      return {
        ...state,
        homeCategories: [],
        homeCategoriesCountry: action.payload?.country || null,
        homeCategoriesFetching: true,
      };

    case FETCH_HOME_CATEGORIES_SUCCESS:
      return {
        ...state,
        homeCategories: Array.isArray(action.payload?.items) ? action.payload.items : [],
        homeCategoriesCountry: action.payload?.country || state.homeCategoriesCountry,
        homeCategoriesFetching: false,
      };

    case FETCH_HOME_CATEGORIES_FAILS:
      return {
        ...state,
        homeCategories: [],
        homeCategoriesFetching: false,
      };

    default:
      return state;
  }
};
